// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 37) return "js/37.js";
	if (chunkId === 654) return "js/654.js";
	if (chunkId === 488) return "js/488.js";
	if (chunkId === 981) return "js/981.js";
	if (chunkId === 731) return "js/731.js";
	if (chunkId === 554) return "js/554.js";
	if (chunkId === 248) return "js/248.js";
	if (chunkId === 800) return "js/800.js";
	if (chunkId === 835) return "js/835.js";
	if (chunkId === 729) return "js/729.js";
	// return url for filenames based on template
	return undefined;
};